import CreateOrUpdateService from "./CreateOrUpdateService";
import CreateOrUpdateParent  from "./CreateOrUpdateParent" ;
import GetOrExistParent      from "./GetOrExistParent"     ;
import ShowServiceList       from "./ShowServiceList"      ;

type CreateNewServiceComponentsType = {
  CreateOrUpdateService: typeof CreateOrUpdateService;
  CreateOrUpdateParent : typeof CreateOrUpdateParent ;
  GetOrExistParent     : typeof GetOrExistParent     ;
  ShowServiceList      : typeof ShowServiceList      ;
}

const CreateNewServiceComponents: CreateNewServiceComponentsType = {
  CreateOrUpdateService,
  CreateOrUpdateParent ,
  GetOrExistParent     ,
  ShowServiceList      ,
};

export default CreateNewServiceComponents;
